module.exports = __webpack_public_path__ + "static/media/amazon_logo.8698a9a6.png";